import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from "vuex-persistedstate"
import Cookies from 'js-cookie'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { loginByAccount, loginByVerificationCode, loginForUserNameAndPhoneApi, ukeyLoginApi, logout, login, loginByKey } from '@/api/login'
import { stat } from 'fs';

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		token: getToken(),
		userInfo: {},
		spaceInfoList: [],

		userContractInfo: {},
		companyList: [],
		currentSpace: {},  // 当前空间id
		orderInfo: {},

		sid: "",
		authid: "",
		handwriteBase64: "",
		handwriteSealId: "",

		contractSift: {}
	},
	mutations: {
		SET_TOKEN: (state, token) => {
			state.token = token
		},
		SET_USER_INFO: (state, info) => {
			state.userInfo = info
		},
		SET_SPACE_INFO_LIST: (state, info) => {
			state.spaceInfoList = info
		},

		SET_USER_CONTRSCT_INFO: (state, info) => {
			state.userContractInfo = info
		},
		SET_COMPSNYL_LIST: (state, info) => {
			state.companyList = info
		},
		SET_CURRENT_SPACE: (state, info) => {
			state.currentSpace = info
		},
		SET_USERNAME: (state, info) => {
			state.userInfo.userName = info
		},
		SET_ORDER_INFO: (state, info) => {
			state.orderInfo = info
		},
		SET_SID: (state, info) => {
			state.sid = info
		},
		SET_AUTHID: (state, info) => {
			state.authid = info
		},
		SET_HANDWRITEBASE64: (state, info) => {
			state.handwriteBase64 = info
		},
		SET_HANDWRITEBASESEALID: (state, info) => {
			state.handwriteSealId = info
		},
		SET_CONTRACTSIFT: (state, info) => {
			state.contractSift = info
		},
		
	},
	actions: {
		accountLogin({ commit }, userInfo) {
			return new Promise((resolve, reject) => {
				loginByAccount(userInfo).then(res => {
					if (res.code != 200) {
						reject(res.message)
					} else {
						setToken(res.data.token, 1)
						resolve()
					}
				})
			})
		},
		vcodeLogin({ commit }, userInfo) {
			return new Promise((resolve, reject) => {
				loginByVerificationCode(userInfo).then(res => {
					if (res.code != 200) {
						reject(res.message)
					} else {
						setToken(res.data.token, 1)
						resolve()
					}
				})
			})
		},



		msgLogin({ commit }, userInfo) {
			// const rememberMe = userInfo.rememberMe
			return new Promise((resolve, reject) => {
				console.log(userInfo)
				loginBySmsCodeApi(userInfo).then(res => {
					console.log(res.code)
					if (res.code != '0') {
						reject(res.message)
					} else {
						// setToken(res.data.token, false)
						resolve(res.data)
					}
				})
			})
		},
		msgAccountLogin({ commit }, userInfo) {

			return new Promise((resolve, reject) => {
				loginForUserNameAndPhoneApi({
					phone: userInfo.phone,
					smsCode: userInfo.smsCode,
					userName: userInfo.userName
				}).then(res => {
					if (res.code != '0') {
						reject(res.message)
					} else {
						resolve(res.data)
					}
				})
			})
		},

		loginByKey({ commit }, userInfo) {
			return new Promise((resolve, reject) => {
				console.log(userInfo)
				loginByKey({
					id: userInfo.id,
					sign: userInfo.sign
				}).then(res => {

					if (res.code !== 0) {
						// this.$message({
						//   showClose: true,
						//   message: res.message,
						//   type: 'warning'
						// });
						reject(res.message)
					} else {
						console.log(res);
						resolve(res.data)
					}

				})
			})
		},
		ukeyLogin({ commit }, userInfo) {
			return new Promise((resolve, reject) => {
				console.log(userInfo)
				ukeyLoginApi({
					phone: userInfo.phone,
					id: userInfo.id,
					code: userInfo.code,
					sign: userInfo.sign
				}).then(res => {
					if (res.code !== 200) {
						// this.$message({
						//   showClose: true,
						//   message: res.message,
						//   type: 'warning'
						// });
						reject(res.message)
					} else {
						setToken(res.data.token, userInfo.rememberMe)
						resolve()
					}

				})
			})
		},
		LogOut({ commit }) {
			return new Promise((resolve, reject) => {
				logout().then(res => {
					commit('SET_TOKEN', '')
					localStorage.removeItem('vuex');
					localStorage.removeItem('config');
					removeToken()
					Cookies.remove('inviteCode')
					resolve()
				}).catch(error => {
					commit('SET_TOKEN', '')
					removeToken()
					localStorage.removeItem('userinfo');
					Cookies.remove('inviteCode')
					reject(error)
				})
			})
		},
	},
	modules: {
	},
	plugins: [createPersistedState()]
})
